<template>
  <div v-if="showFloat" @click.stop class="audio_float">
    <audio
      @timeupdate="updateProgress"
      controls
      ref="audioFloat"
      style="display: none"
    >
      <source :src="$store.state.float.src" type="audio/mpeg" />
      您的浏览器不支持音频播放
    </audio>
    <div v-if="!showDetail" class="float_simp" @click.stop="showDetail = true">
      <i class="icon iconfont icon-icon_yinpin"></i>
    </div>
    <div v-else class="float_open" @click.stop="showDetail = false">
      <div class="audio_detail" @click.stop>
        <i class="icon iconfont icon-icon_yinpin"></i>
        <div class="audio_title">{{ $store.state.float.title }}</div>
        <i class="el-icon-close" @click.stop="closeFloat"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showFloat: this.$store.state.float.showAudio,
      showDetail: false,
      speedList: [2, 1.5, 1, 0.5],
    };
  },
  watch: {
    "$store.state.float.showAudio": {
      // watch里面不能用箭头函数
      handler: function (newVal, oldVal) {
        this.showFloat = newVal;
        if (newVal) {
          setTimeout(() => {
            var myVid = this.$refs.audioFloat;
            myVid.loop = false;
            if (this.$store.state.float.time) {
              myVid.currentTime = Number(
                this.$store.state.float.time * this.$store.state.float.duration
              );
            }
            myVid.playbackRate =
              this.speedList[this.$store.state.float.speed] || 1;
            myVid.volume = 0.5;
            myVid.play();
          }, 1000);
        } else {
          var myVid = this.$refs.audioFloat;
          myVid.pause();
        }
      },
    },
  },
  updated() {
    this.fetch();
  },
  methods: {
    fetch() {
      let that = this;
      var myVid = this.$refs.audioFloat;
      if (!myVid) return;
      myVid.loop = false;
      myVid.oncanplay = function () {
        if (!that.$store.state.float.duration) {
          that.$store.commit("float/setDuration", myVid.duration);
        }
      };
      myVid.addEventListener(
        "ended",
        function () {
          let float = that.$store.state.float;
          float.list[float.id].time = 0;
          float.list[float.id].speed = float.list[float.id].speed;
          that.$store.commit("float/setList", float.list);

          that.$store.commit("float/setSrc", "");

          that.$store.commit("float/setTitle", "");
          that.$store.commit("float/setDuration", 0);
          that.$store.commit("float/setTime", 0);

          setTimeout(() => {
            that.$store.commit("float/setId", "");
            that.$store.commit("float/setAudio", false);
          });
        },
        false
      );
    },
    closeFloat() {
      this.$store.commit("float/setAudio", false);
      this.showDetail = false;
      this.showFloat = false;
    },
    updateProgress(e) {
      var value = e.target.currentTime / e.target.duration;
      this.$store.commit("float/setTime", value);
      let float = this.$store.state.float;
      if (float.list[float.id]) {
        float.list[float.id].time = value;
      } else {
        float.list[float.id] = {
          time: value,
          speed: 2,
        };
      }
      this.$store.commit("float/setList", float.list);

      // if (document.getElementById("progressBar" + this.id)) {
      //   document.getElementById("progressBar" + this.id).style.width =
      //     value * 100 + "%";
      //   if (e.target.currentTime === e.target.duration) {
      //     this.audioStatus = "pause";
      //   }
      // } else {
      //   this.audioStatus = "pause";
      // }

      // this.audioStart = this.transTime(
      //   this.$refs["audioRef" + this.id].currentTime
      // );
    },
  },
};
</script>

<style lang="scss"  scoped>
.audio_float {
  position: fixed;
  top: 30vh;
  right: 0;
  z-index: 999;

  .float_simp {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 30px 0 0 30px;
    background: #fff;
    box-shadow: -4px 2px 20px 4px #ccc;

    i {
      color: #56bf8b;
      font-size: 24px;
    }
  }
  .float_open {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background: rgba(255, 255, 2555, 0.7);
    .audio_detail {
      position: absolute;
      top: 30vh;
      right: 0;
      max-width: 240px;
      height: 36px;
      display: flex;
      align-items: center;
      padding: 0 10px;
      .audio_title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin-right: 10px;
      }
      .icon-icon_yinpin {
        color: #56bf8b;
        font-size: 24px;
        margin-right: 10px;
      }
      .el-icon-close {
        font-size: 16px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/floatAudio.vue